import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ISlidingScale, ISlidingScaleFormData } from '../types';
import { atom } from 'recoil';
import NumericInputLabel from 'components/NumericInputLabel';
import MinusButton from "../../../../components/MinusButton";
import PlusButton from "../../../../components/PlusButton";
import { agreementForEdit } from '../atoms/atoms';

//atoms
export const slidingScaleFormState = atom<ISlidingScaleFormData>({
  key: 'slidingScaleFormState',
  default: {
    fields: [
    {
      premiumRangeStart: null,
      premiumRangeEnd: null,
      percentageRate: null,
      index: 0
    }
    ]
  }
});
export const errorSlidingScale = atom<boolean>({
  key: "errorSlidingScale",
  default: false
});

export function slidingScaleDuplicateChecker(
  array: ISlidingScale[],
  keys: (keyof ISlidingScale)[] = ['premiumRangeStart', 'premiumRangeEnd', 'percentageRate']
): boolean {
  const compareKeys = keys.length > 0 ? keys : Object.keys(array[0] || {}) as (keyof ISlidingScale)[];

  for (let i = 0; i < array.length; i++) {
    for (let j = i + 1; j < array.length; j++) {
      const isDuplicate = compareKeys.every(key => {

        const value1 = array[i][key];
        const value2 = array[j][key];
        
        return value1 === value2;
      });

      if (isDuplicate) {
        return true;
      }
    }
  }
  return false; 
}

export function SlidingScaleForm() {
  const [formData, setFormData] = useRecoilState(slidingScaleFormState);
  const rowForEdit: any = useRecoilValue(agreementForEdit);
  const slidingScales = rowForEdit.slidingScale;
  const isErrorSlidingScale = useRecoilValue(errorSlidingScale); 
  const getEmptyRow = (index: number): ISlidingScale => ({
    premiumRangeStart: null as number | null,
    premiumRangeEnd: null as number | null,
    percentageRate: null as number | null,
    index
  });

  //default values
  useEffect(() => {
    if (slidingScales && slidingScales.length > 0) {
      const sortedScales = [...slidingScales].sort((a, b) => 
        (a.slidingScaleId ?? 0) - (b.slidingScaleId ?? 0)
      );

      const formattedData = sortedScales.map((scale, index) => ({
        ...scale,
        index 
      }));

      setFormData({
        fields: formattedData
      });
    }
  }, [slidingScales, setFormData]);

  //handle add, delete, set
  const handleAppend = () => {
    setFormData(prev => ({
      ...prev,
      fields: [...prev.fields, getEmptyRow(prev.fields.length)]
    }));
  };

  const handleRemove = (indexToRemove: number) => {
    if (indexToRemove === 0) return;
    
    setFormData(prev => ({
      ...prev,
      fields: prev.fields
        .filter((_, i) => i !== indexToRemove)
        .map((field, newIndex) => ({
          ...field,
          index: newIndex 
        }))
    }));
  };

  const handleFieldChange = (index: number, field: keyof ISlidingScale, value: number | null) => {
    setFormData(prev => ({
      ...prev,
      fields: prev.fields.map((item, i) => 
      i === index 
      ? { ...item, [field]: value, index: i }: item
      )
    }));
  };

  return (
    <div className="space-y-4">
      {formData.fields.map((field, index) => (
        <div key={field.index} className="flex items-center gap-10">

          <NumericInputLabel
            label="Premium Range Start"
            value={field.premiumRangeStart ?? ""}
            type="number"
            step="0.01"
            required={true}
            onChange={(e) => {{
              const newValue = e.target.value === "" ? null : e.target.value;
              
              const regex = /^\d{0,15}(\.\d{0,2})?$/;
              if (newValue === null || regex.test(newValue)) {
                handleFieldChange(index, "premiumRangeStart", 
                  newValue === "" || 
                  newValue === null 
                  ? null : Number(newValue));
              }}
            }
            }
            className={
              isErrorSlidingScale ?
              "border-2 border-red-500 col-span-2" : 
              "border border-gray-300 focus:ring-septenary focus:border-septenary col-span-2"
            }
            secondDiv="grid grid-cols-1"
          />
          <NumericInputLabel
            label="Premium Range End"
            value={field.premiumRangeEnd ?? ""}
            type="number"
            step="0.01"
            required={true}
            onChange={(e) =>{
              const newValue = e.target.value === "" ? null : e.target.value;
              
              const regex = /^\d{0,15}(\.\d{0,2})?$/;
              if (newValue === null || regex.test(newValue)) {
                handleFieldChange(index, "premiumRangeEnd", 
                  newValue === "" || 
                  newValue === null 
                  ? null : Number(newValue));
              }}
            }
            className={
              isErrorSlidingScale ?
              "border-2 border-red-500 col-span-2" : 
              "border border-gray-300 focus:ring-septenary focus:border-septenary col-span-2"
            }
            secondDiv="grid grid-cols-1"
          />
          <NumericInputLabel
            label="Percentage Rate"
            value={field.percentageRate ?? ""}
            type="number"
            step="0.01"
            required={true}
            onChange={(e) =>{
              const newValue = e.target.value === "" ? null : e.target.value;

              const regex = /^\d{0,15}(\.\d{0,2})?$/;
              if (newValue === null || regex.test(newValue)) {
                handleFieldChange(index, "percentageRate", 
                  newValue === "" || 
                  newValue === null 
                  ? null : Number(newValue));
              }}
            }
            className={
              isErrorSlidingScale ?
              "border-2 border-red-500 col-span-2" : 
              "border border-gray-300 focus:ring-septenary focus:border-septenary col-span-2"
            }
            secondDiv="grid grid-cols-1"
          />
          <div>
            <div className='mr-5'>
          {index !== 0 && <MinusButton
            onClick={() => {
              handleRemove(index);
            }}
          />}
          </div>
          {index === 0 && <PlusButton
          onClick={
            handleAppend
          }
          />}
          </div>
        </div>
      ))}
    </div>
  );
};
